import { useModuleFederationContext, useSitemap, useUrlContext } from '@msdk/common'
import { readFullModel } from '@msdk/definitions'
import { resolveItemFromAll } from '@msdk/forms'
import { styled } from '@msdk/ui'

const BannerWrapper = styled('div')`
  width: 100%;
`

export function BannerInjector() {
  const urlCtx = useUrlContext()
  const sitemapModel = useSitemap(urlCtx.context.sitemap)
  const modules = useModuleFederationContext()
  const model = readFullModel()
  const componentDef = sitemapModel.banner.componentName
    ? model.customComponents.find((c) => c?.fullName.includes(sitemapModel.banner.componentName))
    : null
  const BannerComponent = resolveItemFromAll(modules, componentDef?.fullName)

  return <BannerWrapper>{BannerComponent && <BannerComponent />}</BannerWrapper>
}
